import { ShareLinkSelectedCommentTarget } from "./share-link-selected-comment-target"

export function ShareLinkSelectedIntroCommentTarget({ children, schedule }) {
    return (
        <ShareLinkSelectedCommentTarget targetType="intro" schedule={schedule}>
            {children}
        </ShareLinkSelectedCommentTarget>
    )
}
